export const BASE_SAMESPACE_API = ".samespace.com/auth/api/accounts";
